import Image from 'next/image';

import './CourseExperts.scss';
import { cn } from '@helpers/styles';
import { Slider } from '@components';

export default function CourseExperts({ experts }) {
  return (
    <section className="courseExperts">
      <div className="courseExperts-content">
        <h2 className="courseExperts-title">Maak kennis met onze experts</h2>

        <Slider
          visibleSlides={3}
          slides={experts.map((expert, idx) => (
            <div className="courseExperts-card" key={idx}>
              <Image
                className="courseExperts-card-avatar"
                src={expert.avatar}
                alt={`${expert.role} ${expert.name}`}
                sizes="(min-width: 1200px) 150px, 100px"
                placeholder="blur"
              />

              <div
                className={cn('courseExperts-card-text', {
                  'courseExperts-card-text-with-divider': idx !== 0
                })}
              >
                <p className="courseExperts-card-name">{expert.name}</p>
                <p className="courseExperts-card-role">{expert.role}</p>
                <p
                  className="courseExperts-card-description"
                  dangerouslySetInnerHTML={{ __html: expert.description }}
                />
              </div>
            </div>
          ))}
        />
      </div>
    </section>
  );
}
